import React, { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Coupon from "../UI/Coupon";
import {
  getCouponsBasedOnDomainAction,
  getEndUserAction,
  getFeatureCardsAction,
  getRecommendBannerAction,
} from "../../redux/actions";
import CustomLoader from "../UI/CustomLoader";
import { getCouponByIdAction } from "../../redux/actions";
import { Link } from "react-router-dom";
import { zoomIn } from "react-animations";
import styled, { keyframes } from "styled-components";
import { getAdIndex, getImageByType, getImageUrl } from "../../utils";
import { BASE_URL } from "../../services/axiosInstance";

const zoomInAnimation = keyframes`${zoomIn}`;

const ZoomInDiv = styled.div`
  animation: 1s ${zoomInAnimation};
`;

const DealSectionOne = ({ match }) => {
  const dispatch = useDispatch();

  const [selectedCoupon, setSelectedCoupon] = useState(null);

  const { featureCards, domainData } = useSelector((state) => state.Website);
  const { couponbaseondomainList, loading } = useSelector(
    (state) => state.CouponBasedOnDomain
  );
  const { couponByID } = useSelector((state) => state.Coupon);
  const { getEndUser } = useSelector((state) => state.Coupon);

  const adBanners = useMemo(()=>{
    return getEndUser.filter(i=>i.banner_dimension==="300 * 250").map(i=>({...i, banner_url:getImageByType(i.image_type, i.image_url ,i.image_upload)}))
  },[getEndUser])

  useEffect(() => {
    dispatch(getFeatureCardsAction());
  }, []);

  useEffect(() => {
    dispatch(getCouponsBasedOnDomainAction());
      dispatch(getEndUserAction());
  }, [dispatch]);

  useEffect(() => {
    function fetch() {
      if (
        match?.params?.couponId !== undefined &&
        couponByID?._id === undefined
      ) {
        dispatch(getCouponByIdAction({ coupon_id: match.params.couponId }));
      }
      if (
        match?.params?.couponId !== undefined &&
        couponByID?._id !== undefined
      ) {
      //   window.open(
      //     `/couponsredirect/coupon/${match.params.storeName}/${match.params.couponId}`,
      //     "_blank"
      //   );
      // }
        window.open(
          `/${match.params.storeName}/${match.params.couponId}`,
          "_blank"
        );
      }
    }
    fetch();
  }, [match, couponByID, dispatch]);

  return (
    <section id="page" class="container" style={{ padding: "2% 0"}}>
      {featureCards && featureCards.length>0 && <div class="shadow bg-white mTop-30 frameLR">
        <div class="row custom-row">
          {featureCards.map((card) => (
            <div class="col-md-3 col-sm-4">
              <div class="l-element">
                <div class="box-icon">
                  <div class="icon-wrap" style={{ paddingLeft: "30%" }}>
                    <img
                      alt="icon"
                      src={getImageUrl(card?.icon)}
                      style={{ objectFit: "contain" }}
                      width="100"
                      height="100"
                    />
                  </div>
                  <div class="text">
                    <h4>{card?.title}</h4>
                    <p>{card?.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>}

      {couponbaseondomainList?.length > 0  && <h4 className="Recommended">Top Deals</h4>}
      <div class="no-class mTop-30">
        <div class="row custom-row cursor-pointer">
          {loading ? (
            <CustomLoader />
          ) : (
            couponbaseondomainList &&
            couponbaseondomainList.length > 0 &&
            couponbaseondomainList.slice(0, 20).map((data, index) =>(
              <>
                {(index+1)%4 === 0 && adBanners[getAdIndex(index,4)] && (
                <div
                  className="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                  // className="mb-1 pb-3"
                  key={index}
                  id="home1-banner"
                  style={{
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "400px",
                    maxWidth: "315px",
                    marginLeft: "12px",
                    position: "relative",
                  }}
                >
                  <h4 style={{ position:"absolute", top:15, left:15, textAlign:"center",width:"100%" }} >
                    {
                      adBanners[getAdIndex(index,4)]?.caption?.length > 48 ? 
                      adBanners[getAdIndex(index,4)].caption.substring(0, 48) + "..." : 
                      adBanners[getAdIndex(index,4)].caption
                    }
                  </h4>
                  <ZoomInDiv className="d-flex align-items-center cursor-pointer flex-column justify-content-center couponCard h-100">
                    <a target="_blank" href={adBanners[getAdIndex(index,4)]?.redirect_url}>
                      <img
                        style={{
                          objectFit: "contain",
                          maxWidth: "280px",
                        }}
                        src={adBanners[getAdIndex(index,4)]?.banner_url}
                        alt="Banner 1"
                      />
                    </a>
                  </ZoomInDiv>
                </div>)}
                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                  <Coupon
                    couponData={data}
                    setSelectedCoupon={setSelectedCoupon}
                    selectedCoupon={selectedCoupon}
                  />
                </div>
              </>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(DealSectionOne);
